<div class="footer">
  <div class="container-fluid">
      <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 text-center text-lg-left">
               Copyright © 2024. All rights reserved. Dashboard by <a href="#">Nukhba</a>.
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
              <div class="text-center text-lg-right footer-links d-none d-sm-block">
                  <a routerLink="/webview/about-us" routerLinkActive="true">About</a>
                  <a routerLink="/webview/privacy-policy" routerLinkActive="true">Privacy Policy</a>
                  <a routerLink="/webview/terms-n-condition" routerLinkActive="true">Terms and Condition</a>
                  <!-- <a routerLink="/webview/support" routerLinkActive="true">Support</a> -->
                  <!-- <a routerLink="/webview/faq" routerLinkActive="true">Faq</a> -->
              </div>
          </div>
      </div>
  </div>
</div>